import { configure as configureWidget } from "instantsearch.js/es/widgets";

const wrapper = document.querySelector('[data-product-algolia]')
const filters = wrapper.dataset.filters ?? ''

export const productsConfigure = configureWidget({
    filters: filters,
    hitsPerPage: 40,
    distinct: true,
    facetingAfterDistinct: true,
});
